import React, { FC, useEffect } from "react";
import styles from "./Planos.module.scss";
import Logo from "./../../../../Static/Images/VETSaúde-Logo.png";
import { SiteButton } from "../../../../Components/UI/Button/Button.style";
import { useHistory } from "react-router-dom";
import { PlanosHelper } from "../../../../Utils/Planos";
import { IPlanoContext } from "../../../../Context/Plano/Interfaces/IPlanoContext";
import { isMobile } from "react-device-detect";
import BgTitlePlan from "./../../../../Static/Images/Planos/BgTitle.png";
import CheckIcon from "./../../../../Static/Images/Planos/check.png";
import BlackFridayTagIcon from "./../../../../Static/Images/Planos/BlackFriday.png";

interface IPlanos {
  planosContext: IPlanoContext;
}

const Planos: FC<IPlanos> = ({ planosContext }) => {
  const history = useHistory();

  useEffect(() => {
    planosContext.effects && planosContext.effects.getAllPlanos();
  }, []);

  return (
    <div className={`${styles["Planos"]}  ${isMobile ? styles["mobile"] : ""}`}>
      <img src={Logo} alt="Vet Saude Logo" className={styles["Logo"]} />
      <span className={styles["Title"]}>Nossos Planos</span>
      <div
        className={`${styles["Planos"]} ${isMobile ? styles["mobile"] : ""}`}
      >
        {((planosContext.planos && planosContext.planos.data) || []).map(
          (plan, idx) => {
            const itemsPlan: string[] = [];
            if (plan.limiteConsultas === -1 || plan.limiteConsultas > 0) {
              itemsPlan.push("Consulta Domiciliar");
            }
            if (plan.vacinas === -1 || plan.vacinas > 0) {
              itemsPlan.push("Vacinas Importadas");
            }
            if (plan.vermifugos === -1 || plan.vermifugos > 0) {
              itemsPlan.push("Vermifugação");
            }
            if (plan.limiteEmergencias === -1 || plan.limiteEmergencias > 0) {
              itemsPlan.push("Atendimento Emergencial");
            }
            if (plan.cooparticipacao > 0) {
              itemsPlan.push(`${plan.cooparticipacao}% de Coparticipação`);
            }
            return (
              <div className={styles["Plan"]}>
                <div className={styles["Group"]}>
                  <div className={styles["Title"]}>
                    <img src={BgTitlePlan} alt="Bg Plan" />
                    {plan.value_discount > 0 && (
                      <img
                        src={BlackFridayTagIcon}
                        className={styles["BlackFriday"]}
                      />
                    )}

                    <p>
                      <span>{plan.nome}</span>
                      <span>
                        <span
                          style={{
                            fontSize: "var(--font-size-smd)",
                          }}
                        >
                          R$
                        </span>
                        {PlanosHelper.getPlanoVal(
                          plan,
                          plan.interval_type,
                          false
                        ).replace("R$", "")}
                      </span>
                      <span
                        style={{
                          fontSize: "var(--font-size-smd)",
                        }}
                      >
                        POR MÊS
                      </span>
                    </p>
                  </div>
                  <div className={styles["Items"]}>
                    {itemsPlan.map((title) => (
                      <div className={styles["Item"]}>
                        <img src={CheckIcon} />
                        <span>{title}</span>
                      </div>
                    ))}
                  </div>
                  <p className={styles["NaoCobre"]}>
                    Os planos não cobrem cirurgias como castração, limpeza{" "}
                    <br />
                    odontológica e etc; internações e exames complementares
                  </p>
                </div>
                <SiteButton
                  className={styles["plano-contratar"]}
                  onClick={() => {
                    history.push(`/venda/${plan.identifier}`);
                  }}
                  color="--btn-primary"
                >
                  <span>Quero Esse!</span>
                </SiteButton>
              </div>
            );
          }
        )}
      </div>
      <div className={styles["Tabela"]}>
        {/* <table>
          <thead>
            <tr className={styles["header"]}>
              <td className={styles["title"]} rowSpan={2}>
                Beneficios
              </td>
              {((planosContext.planos && planosContext.planos.data) || []).map(
                (item, idx) => {
                  return <td key={`header-plano-name-${idx}`}>{item.nome}</td>;
                }
              )}
            </tr>
            <tr className={styles["valores"]}>
              {((planosContext.planos && planosContext.planos.data) || []).map(
                (item, idx) => {
                  return (
                    <td key={`header-plano-${idx}`} className={styles["valor"]}>
                      {item.interval > 1 && <span>{item.interval}x de </span>}
                      {PlanosHelper.getPlanoVal(
                        item,
                        item.interval_type,
                        item.interval <= 1
                      )}
                      <br />
                      {item.interval > 1 && (
                        <span>
                          {PlanosHelper.getPlanoVal(
                            item,
                            item.interval_type,
                            true,
                            item.max_cycles === 0 ? 12 : item.max_cycles + 1
                          )}
                        </span>
                      )}
                      {item.startAt &&
                        moment(item.startAt).isAfter(new Date()) && (
                          <>
                            <br />
                            <span className={styles["disponibilidade-uso"]}>
                              *Disponível para uso a partir de{" "}
                              {moment(new Date(item.startAt)).format(
                                "DD/MM/YYYY"
                              )}
                            </span>
                          </>
                        )}
                    </td>
                  );
                }
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Consultas em horário comercial à domicilio</td>
              {((planosContext.planos && planosContext.planos.data) || []).map(
                (item, idx) => {
                  return (
                    <td key={`consultas-${idx}`}>
                      {item.limiteConsultas === 0
                        ? "-"
                        : item.limiteConsultas === -1
                        ? "Ilimitado"
                        : item.limiteConsultas}
                    </td>
                  );
                }
              )}
            </tr>
            <tr>
              <td>Vacinas</td>
              {((planosContext.planos && planosContext.planos.data) || []).map(
                (item, idx) => {
                  return (
                    <td key={`vacinas-${idx}`}>
                      {item.vacinas === 0
                        ? "-"
                        : item.vacinas === -1
                        ? "Ilimitado"
                        : item.vacinas}
                    </td>
                  );
                }
              )}
            </tr>
            <tr>
              <td>Vermifugos</td>
              {((planosContext.planos && planosContext.planos.data) || []).map(
                (item, idx) => {
                  return (
                    <td key={`vermifugos-${idx}`}>
                      {item.vermifugos === 0
                        ? "-"
                        : item.vermifugos === -1
                        ? "Ilimitado"
                        : item.vermifugos}
                    </td>
                  );
                }
              )}
            </tr>
            <tr>
              <td>Consultas emergenciais em horário de plantão</td>
              {((planosContext.planos && planosContext.planos.data) || []).map(
                (item, idx) => {
                  return (
                    <td key={`emergencias-${idx}`}>
                      {item.limiteEmergencias === 0
                        ? "-"
                        : item.limiteEmergencias === -1
                        ? "Ilimitado"
                        : item.limiteEmergencias}
                    </td>
                  );
                }
              )}
            </tr>
            <tr>
              <td>
                Coparticipação (modalidade de plano com mensalidade reduzida, na
                qual o usuário paga determinada % por cada serviço quando
                utilizar)
              </td>
              {((planosContext.planos && planosContext.planos.data) || []).map(
                (item, idx) => {
                  return (
                    <td key={`cooparticipacao-${idx}`}>
                      {item.cooparticipacao === 0
                        ? "Não possui"
                        : `${item.cooparticipacao}%`}
                    </td>
                  );
                }
              )}
            </tr>
            <tr>
              <td>
                Os planos não cobrem cirurgias como castração, limpeza
                odontológica e etc; internações e exames complementares
              </td>
              {((planosContext.planos && planosContext.planos.data) || []).map(
                (item, idx) => {
                  return (
                    <td key={`btn-${idx}`}>
                      <div>
                        <SiteButton
                          className={styles["plano-contratar"]}
                          onClick={() => {
                            // history.push(`/${item.identifier}`);
                            // const form = document.getElementById("formContato");
                            // const inputNome =
                            //   document.getElementById("inputNome");
                            // if (form && inputNome) {
                            //   form.classList.add("tremer");
                            //   setTimeout(() => {
                            //     form.classList.remove("tremer");
                            //   }, 450);
                            //   const x = window.scrollX,
                            //     y = window.scrollY;
                            //   inputNome.focus();
                            //   window.scrollTo(x, y);
                            // }
                            history.push(`/venda/${item.identifier}`);
                          }}
                          color="--btn-primary"
                        >
                          <span>Quero Esse!</span>
                        </SiteButton>
                      </div>
                    </td>
                  );
                }
              )}
            </tr>
          </tbody>
        </table> */}
      </div>
      {/* {!isMobile && (
        <SiteButton
          className={styles["personalizarPlano"]}
          onClick={() => {
            const form = document.getElementById("formContato");
            const inputNome = document.getElementById("inputNome");
            if (form && inputNome) {
              form.classList.add("tremer");
              setTimeout(() => {
                form.classList.remove("tremer");
              }, 450);
              inputNome.focus();
              scroller.scrollTo("formContato", {
                duration: 500,
                smooth: true,
              });
            }
          }}
          color={"--bg-gradient-primary"}
        >
          <div className={styles["border"]}>Faça um plano Personalizado</div>
        </SiteButton>
      )}
      {isMobile && (
        <Link
          className={`${styles["personalizarPlano-link"]} ${styles["personalizarPlano"]}`}
          activeClass="active"
          to="formContato"
          onClick={() => {
            const form = document.getElementById("formContato");
            const inputNome = document.getElementById("inputNome");
            if (form && inputNome) {
              form.classList.add("tremer");
              setTimeout(() => {
                form.classList.remove("tremer");
              }, 450);
              inputNome.focus();
              scroller.scrollTo("formContato", {
                duration: 500,
                smooth: true,
              });
            }
          }}
          spy={true}
          smooth={true}
          duration={500}
        >
          <div className={styles["border"]}>Faça um plano Personalizado</div>
        </Link>
      )} */}
    </div>
  );
};

export default Planos;
